import { render, staticRenderFns } from "./ClaimList.vue?vue&type=template&id=08cb29eb&scoped=true&"
import script from "./ClaimList.vue?vue&type=script&lang=js&"
export * from "./ClaimList.vue?vue&type=script&lang=js&"
import style0 from "./ClaimList.vue?vue&type=style&index=0&id=08cb29eb&lang=scss&scoped=true&"
import style1 from "./ClaimList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb29eb",
  null
  
)

export default component.exports